<template>
  <div>
    <div class="card dashcard">
      <div class="card-body">
        <div class="form-row">
          <div class="col col-12 col-md-6">
            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fa fa-filter"
              placeholder="Data de Pagamento"
              optionsData="id"
              :optionsList="[
                { id: 'A', search: 'Data de Atendimento'},
                { id: 'R', search: 'Data de Registro'},
              ]"
              v-model="filtro.tipo_data" />
          </div>
          
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fas fa-user fa-fw"
              placeholder="Todos"
              optionsData="id_usuario"
              :optionsList="usuarios"
              :edicao="!fechamento_recepcao || fechamento_geral"
              v-model="id_usuario" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fa fa-filter"
              placeholder="Todos os Status Ativos..."
              optionsData="id"
              :optionsList="[
                { id: 'P', search: 'A Enviar/Receber'},
                { id: 'F', search: 'Fechado'},
                { id: 'PF', search: 'A Enviar/Rec + Fechado'},
                { id: 'A', search: 'Recebido (Todos)'},
                { id: 'AB', search: 'Recebido (Baixados)'},
                { id: 'AZ', search: 'Recebido (Não Baixados)'},
                { id: 'C', search: 'Cancelados'}
              ]"
              v-model="filtro.status" />
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col col-12 col-md-2">
            <az-input
              icon="fa fa-credit-card-alt"
              placeholder="Todos os Particulares..."
              type="select"
              optionsMode="aql"
              optionsData="id_plano"
              optionsDisplay="st_plano"
              service="planos.index"
              :optionsParm="{ cadastro_unidade: true }"
              optionsName="planos-particulares"
              v-model="id_plano" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              :edicao="!$store.state.user.id_unidade_operacao"
              icon="far fa-building fa-fw"
              type="select"
              placeholder="Todas"
              :optionsList="$util.unidades_com_tags(true, true)"
              optionsData="id_unidade_operacao"
              v-model="id_unidade_operacao" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
                icon="fas fa-concierge-bell fa-fw"
                type="select"
                placeholder="Todas as Recepções..."
                :optionsList="lista_recepcoes"
                optionsData="id_recepcao"
                :edicao="id_unidade_operacao > 0"
                v-model="id_recepcao" />
          </div>
          <div class="col col-12 col-md-2">
              <az-input icon="fas fa-user-md fa-fw" 
                  type="select" 
                  optionsMode="aql"
                  service="medicos.index"
                  optionsName="medicos-guia"
                  optionsData="id_pessoa"
                  placeholder="Todos Executantes..."
                  :optionsParm="{ ativos: true }"
                  v-model="filtro.id_medico" />
          </div>
          <div class="col col-12 col-md-4">
            <az-input
              placeholder="Selecionar paciente..."
              icon="fas fa-user"
              type="autocomplete"
              optionsMode="aql"
              service="pacientes.index"
              optionsDisplay="search"
              ref="info_paciente"
              v-model="paciente"
              :optimized_ac="true">
            </az-input>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col col-12 col-md-2">
            <az-input
              placeholder="Todas as Formas..."
              icon="fas fa-cash-register"
              type="select"
              optionsMode="aql"
              service="forma_pagamentos.index"
              optionsData="id_forma_pagamento"
              optionsDisplay="search"
              v-model="id_forma_pagamento" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              placeholder="Pago Para a Clínica"
              icon="fas fa-cash-register"
              type="select"
              :optionsList="[
                { id: 'M', search: 'Pago Para o Médico' }, 
                { id: 'G', search: 'Geral' }, 
              ]"
              optionsData="id"
              optionsDisplay="search"
              v-model="pago_para" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              placeholder="Todos..."
              type="select"
              :optionsList="[
                { id: 'S', search: 'Com NF' }, 
                { id: 'N', search: 'Sem NF' }, 
                { id: '1', search: 'Gerada' }, 
                { id: '4', search: 'Emitida' }, 
              ]"
              optionsData="id"
              optionsDisplay="search"
              v-model="filtro.status_nf">
              <template v-slot:button-pre>
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">NF</span>
                </div>
              </template>
            </az-input>
          </div>
          <div class="col col-12 col-md-6">
            <az-input
              icon="fa fa-search fa-fw"
              placeholder="Digite # + Número do Atendimento para buscar um específico..."
              v-model="search">
              <template v-slot:buttonposb>
                <print-export printid="prestacao-de-contas" :dados="dadosFormatados" :left="true">
                    <template v-slot:dropdownitem>
                        <relatorios-linkados
                            ref="linkados"
                            pagina="fechamento-particular"
                            :apenas_links="true"
                            :parms="{ 
                                unidade: id_unidade_operacao,
                                usuario: $store.state.user.id_usuario,
                                lancamento_id: lista ? lista.map(lanc => lanc.id_lancamento) : null,
                                backlink: ( tipo == 'envio' ? '/recepcao/envio' : '/financeiro/prestacao' ), 
                            }" 
                        />
                    </template>
                </print-export>

                <div class="input-group-append" v-if="false">
                    <relatorios-linkados
                        ref="linkados"
                        pagina="fechamento-particular"
                        :parms="{ 
                            unidade: id_unidade_operacao,
                            usuario: $store.state.user.id_usuario,
                            lancamento_id: lista ? lista.map(lanc => lanc.id_lancamento) : null,
                            backlink: ( tipo == 'envio' ? '/recepcao/envio' : '/financeiro/prestacao' ), 
                        }"
                    />
                </div>
              </template>
            </az-input>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column mb-3" v-if="dados && dados.zoop">
        <az-input
            type="button-group"
            :optionsList="[
                { id: '', search: 'Lançamentos' }, 
                { id: 'S', search: 'Zoop - Para Split' }, 
                { id: 'R', search: 'Zoop - Split Realizado' }, 
                { id: 'P', search: 'Zoop - Pagamento Pendente' }, 
            ]"
            @input="load()"
            v-model="split_zoop">
        </az-input>
    </div>
      
    <template v-if="!lista || !lista.length">
      <az-empty-state icon="fas fa-clipboard-check" msg="Nenhum lançamento identificado." />
    </template>

    <div id="prestacao-de-contas" v-else>

      <div class="card" v-if="dados && dados.fechamentos && dados.fechamentos.length">
        <div class="card-header d-flex justify-content-between">
          <div>
            <a href="#" @click.prevent="show_fechamentos = !show_fechamentos" class="card-link">
              Fechamentos e Recebimentos  
            </a>
          </div>
          <div>
            <span class="badge badge-secondary">
              {{ dados.fechamentos.length }}
            </span>
          </div>
        </div>
        <template v-if="show_fechamentos">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between" v-for="(fechamento, ifx) in dados.fechamentos" :key="ifx">
              <div>
                <a href="#" @click.prevent="buscar_fechamento(fechamento)" class="card-link">
                  {{ $util.getFormatDate(fechamento.created_at) }}
                  {{ fechamento.created_at.slice(11,16) }}
                  <span class="ml-3">
                    {{ fechamento.usuario.st_login }}
                  </span>
                  <span class="badge badge-secondary ml-3" title="Id">
                    #{{ fechamento.id_fechamento_particular }}
                  </span>
                  <span class="badge badge-dark ml-3" title="Tipo">
                    {{ fechamento.tipo }}
                  </span>
                </a>
              </div>
              <div>
                <span class="badge badge-secondary">
                  {{ fechamento.items_count }}
                </span>
              </div>
            </li>
          </ul>
        </template>
      </div>

      <div class="d-none d-print-block mt-3">
        <h4>{{ $store.state.unidade.st_nome_fantasia }}</h4>
        <h3>Prestação de Contas</h3>
        <div class="alert alert-secondary mb-3">
          <div>
            Período: {{ $util.filtro_2_periodo(filtro) }}
          </div>
          <div v-if="search">
            Pesquisa: {{ search }}
          </div>
        </div>
      </div>

      <div class="card" v-if="dados.pendentes && dados.pendentes.atendimentos && dados.pendentes.atendimentos.length">
        <div class="card-header alert-danger d-flex justify-content-between">
          <div>
            <a href="#" @click.prevent="show_pendentes = !show_pendentes" class="card-link">
              <i class="fa fa-plus-square-o fa-fw mr-2" aria-hidden="true" v-if="!show_pendentes"></i>
              <i class="fa fa-minus-square-o fa-fw mr-2" aria-hidden="true" v-else></i>
              <strong>
                {{ dados.pendentes.atendimentos.length }} {{ dados.pendentes.atendimentos.length > 1 ? 'atendimentos' : 'atendimento' }} sem pagamento registrado.
              </strong>
            </a>
          </div>
          <div>
            Total Pendente: {{ $util.formatMoeda(totalizar(dados.pendentes.atendimentos, 'valor_em_aberto')) }}
          </div>
        </div>
        <table class="table table-sm mb-0 small" v-if="show_pendentes">
            <thead>
              <tr>
                <th>Atendimento</th>
                <th>Data</th>
                <th>Paciente</th>
                <th>Responsável</th>
                <th class="text-right">Valor</th>
                <th class="text-right">Atendimento</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(atd, iax) in dados.pendentes.atendimentos" :key="iax">
                <td>
                  <a href="#" @click.prevent="abrir_atendimento(atd.id_atendimento)" class="alert-link">
                    #{{ atd.id_atendimento }}
                  </a>
                </td>
                <td>
                  {{ $util.getFormatDate(atd.dt_inicio) }}
                </td>
                <td>
                  {{ atd.marcacao.paciente.st_nome }}
                </td>
                <td>
                  {{ atd.usuario ? atd.usuario.st_login : '' }}
                </td>
                <td class="text-right">
                  <span v-if="atd.valor_em_aberto > 0">
                    {{ $util.formatMoeda(atd.valor_em_aberto) }}
                  </span>
                </td>
                <td class="text-right">
                  {{ $util.formatMoeda(totalizar(atd.atendimento_procedimentos, 'cd_valor_total')) }}
                </td>
              </tr>
            </tbody>
          </table>
      </div>

      <div class="alert alert-danger d-flex justify-content-between" v-if="1==0 && dados.pendentes && dados.pendentes.atendimentos && dados.pendentes.atendimentos.length">

        <div>
          {{ dados.pendentes.atendimentos.length }} {{ dados.pendentes.atendimentos.length > 1 ? 'atendimentos' : 'atendimento' }} sem pagamento registrado.

          <table class="table table-sm mb-0">
            <tbody>
              <tr v-for="(atd, iax) in dados.pendentes.atendimentos" :key="iax">
                <td>
                  <a href="#" @click.prevent="abrir_atendimento(atd.id_atendimento)" class="alert-link">
                    #{{ atd.id_atendimento }}
                  </a>
                </td>
                <td>
                  {{ $util.getFormatDate(atd.dt_inicio) }}
                </td>
                <td>
                  {{ atd.marcacao.paciente.st_nome }}
                </td>
                <td>
                  <span v-if="atd.valor_em_aberto > 0">
                    {{ $util.formatMoeda(atd.valor_em_aberto) }} /
                  </span>
                  {{ $util.formatMoeda(totalizar(atd.atendimento_procedimentos, 'cd_valor_total')) }}
                </td>
              </tr>
            </tbody>
          </table>

          <ul class="mb-0" v-if="false">
            <li v-for="(atd, iax) in dados.pendentes.atendimentos" :key="iax">
              <a href="#" @click.prevent="abrir_atendimento(atd.id_atendimento)" class="alert-link">
                #{{ atd.id_atendimento }}
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                {{ $util.getFormatDate(atd.dt_inicio) }}
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                {{ atd.marcacao.paciente.st_nome }}
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                <span v-if="atd.valor_em_aberto > 0">
                  {{ $util.formatMoeda(atd.valor_em_aberto) }} /
                </span>
                {{ $util.formatMoeda(totalizar(atd.atendimento_procedimentos, 'cd_valor_total')) }}
              </a>
            </li>
          </ul>
        </div>

        <div>
          Total: {{ $util.formatMoeda(totalizar(dados.pendentes.atendimentos, 'valor_em_aberto')) }}
        </div>

      </div>

      <div class="card" v-if="total_usuarios >= 1"> <!-- v-if="!fechamento_recepcao" -->
        <div class="card-body">
          <div class="row">
            <div class="col col-12 col-md-3">
              <div>Total</div>
              <div class="lead text-success">{{ $util.formatMoeda (total) }}</div>

              <div class="small text-muted mt-2" v-if="adiantamentos > 0">
                <div>Adiantamentos</div>
                <div>{{ $util.formatMoeda (adiantamentos) }}</div>
              </div>
            </div>
            <div class="col col-12 col-md-7 d-flex">
              <div v-for="(valor, chave, icx) in consolidado" :key="icx" class="mx-3">
                <div class="small text-muted">{{ chave }}</div>
                <span class="lead">{{ $util.formatMoeda(valor) }}</span>
              </div>
            </div>
            <div class="col col-12 col-md-2 text-right d-print-none">
              <az-input
                sizing="sm"
                type="button-group"
                :optionsList="[
                  { id: 'G', search: 'Geral' },
                  { id: 'F', search: 'Forma' },
                  { id: 'U', search: 'Usuário' },
                ]"
                optionsData="id" 
                v-model="tipo_quebra"
                @input="cache_tipo_quebra()" />

              <!--
              <button type="button" class="btn btn-sm mb-1" :class="por_usuario ? 'btn-primary' : 'btn-outline-primary'" @click="togglePorUsuario()" v-if="false">
                Por Usuário
              </button>
              -->

              <button class="btn btn-outline-primary btn-sm mb-1 ml-1" type="button" data-toggle="collapse" data-target=".multi-collapse" aria-expanded="false" aria-controls="multiCollapseExample1 multiCollapseExample2">
                <i class="fa-solid fa-minimize"></i>
              </button>

              <button type="button" class="btn btn-sm mb-1 ml-1 btn-outline-primary" @click="marcarTodos(lista)">
                Todos
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-for="(items, usuario, iux) in lista_por_usuario" :key="iux" class="mb-3">

        <div class="card mb-0" v-if="tipo_quebra != 'G'">
          <div class="card-body">
            <div class="row">
              <div class="col col-12 col-md-3">
                <a data-toggle="collapse" :href="'#collapse' + iux" role="button">
                  {{ usuario }}
                </a>
              </div>
              <div class="col col-12 col-md-7 d-flex">
                <div class="mx-3" v-if="tipo_quebra != 'F'">
                  <div class="small text-muted">Total</div>
                  <span class="lead">{{ $util.formatMoeda(total_valor(items, true, true)) }}</span>
                </div>

                <div v-for="(valor, chave, icx) in consolidar(items, true)" :key="'L' + iux + '-' + icx" class="mx-3">
                  <div class="small text-muted">{{ chave }}</div>
                  <span class="lead">{{ $util.formatMoeda(valor) }}</span>
                </div>
              </div>

              <div class="col col-12 col-md-2 text-right d-print-none">
                <button type="button" class="btn btn-sm btn-outline-primary" @click="marcarTodos(items)">
                  Todos
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="collapse show multi-collapse" :id="'collapse' + iux">
          <table class="table table-hover table-responsive-md bg-white small cabecalho-fixo">
            <thead>
              <tr>
                <table-th title="Data" v-model="ordem" sortby="dt_emissao"></table-th>
                <table-th title="Und" v-model="ordem" sortby="unidade_operacao.st_sigla"></table-th>
                <table-th title="Paciente" v-model="ordem" sortby="item_pagamento_atendimento.pagamento_atendimento.nome_paciente"></table-th>
                <table-th title="Forma de Pagamento" v-model="ordem" sortby="forma_pagamento.search"></table-th>
                <table-th title="Profissional" v-model="ordem" sortby="profissional"></table-th>
                <table-th title="Responsável" v-model="ordem" sortby="usuario.st_login" v-if="tipo_quebra != 'U'"></table-th>
                <table-th title="Recibo" v-model="ordem" sortby="item_pagamento_atendimento.id_pagamento_atendimento"></table-th>
                <th>NF</th>
                <table-th class="text-right" title="Valor" v-model="ordem" sortby="total_valor"></table-th>
                <th class="text-center">Recebido</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lancs, ilx) in lista_agrupada(items)" :key="ilx">
                <td>
                  {{ $util.getFormatDate(lancs[0].dt_emissao) }}
                  <div class="small text-muted">
                    <span v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.id_atendimento">
                      <a href="#" @click.prevent="abrir_atendimento(lancs[0].item_pagamento_atendimento.pagamento_atendimento.id_atendimento)" class="card-link">
                        #{{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.id_atendimento }}
                      </a>

                      <span v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.progresso_atendimento && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.progresso_atendimento.id_etapa_atendimento == 7" title="Atendimento Realizado." class="card-link ml-1">
                        <i class="fa fa-check-circle text-success" aria-hidden="true"></i>
                      </span>

                      <span v-else-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.progresso_atendimento && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.progresso_atendimento.id_etapa_atendimento == 10" title="Não Compareceu." class="card-link ml-1">
                        <i class="fa fa-times-circle text-secondary" aria-hidden="true"></i>
                      </span>

                      <!-- Anexos -->
                      <a href="#" 
                        @click.prevent="abrir_anexar_arquivo(lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao)" 
                        class="card-link ml-2" 
                        v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento
                        && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao
                        && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.arquivos
                        && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.arquivos.length">
                        <i class="fa fa-paperclip" aria-hidden="true"></i>
                      </a>

                      <span class="text-muted ml-3"
                        v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento
                          && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao
                          && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.st_id_externo">
                          {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.st_id_externo }}
                      </span>
                    </span>

                    <span v-else-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.link_atendimentos && lancs[0].item_pagamento_atendimento.pagamento_atendimento.link_atendimentos.length">
                      <div v-for="(pag_link, ipx) in lancs[0].item_pagamento_atendimento.pagamento_atendimento.link_atendimentos" :key="ipx">
                        <a href="#" @click.prevent="abrir_atendimento(pag_link.model_id)" class="card-link">
                          #{{ pag_link.model_id }}
                        </a>

                        <span v-if="pag_link.atendimento && pag_link.atendimento.progresso_atendimento && pag_link.atendimento.progresso_atendimento.id_etapa_atendimento == 7" title="Atendimento Realizado." class="card-link ml-1">
                            <i class="fa fa-check-circle text-success" aria-hidden="true"></i>
                        </span>

                        <span v-else-if="pag_link.atendimento && pag_link.atendimento.progresso_atendimento && pag_link.atendimento.progresso_atendimento.id_etapa_atendimento == 10" title="Não Compareceu." class="card-link ml-1">
                            <i class="fa fa-times-circle text-secondary" aria-hidden="true"></i>
                        </span>
                      </div>
                    </span>

                    <span v-else-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.dc_valor_adiantado">
                      Adiantamento
                    </span>
                  </div>

                  <div v-if="lancs[0].fechamento_particular_items && lancs[0].fechamento_particular_items.length">
                    <a href="#" @click.prevent="ver_fechamentos(lancs)">
                      <span class="badge" :class="'badge-' + ( lancs[0].fechamento_particular_items[0].fechamento.cor ? lancs[0].fechamento_particular_items[0].fechamento.cor : 'dark' )">
                        {{ lancs[0].fechamento_particular_items[0].fechamento.tipo }}
                      </span>
                    </a>
                  </div>
                </td>

                <!-- Unidade -->
                <td>
                  <span class="badge badge-light" v-if="lancs[0].unidade_operacao && lancs[0].unidade_operacao.st_sigla">
                    {{ lancs[0].unidade_operacao.st_sigla }}
                  </span>
                </td>

                <!-- Paciente -->
                <td>
                  {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.nome_paciente }}
                  <div class="text-muted" v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.plano">
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.plano.search }}
                  </div>
                  <div class="text-muted" v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento 
                      && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.plano">
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.plano.search }}
                  </div>
                </td>

                <!-- Forma Pagamento  -->
                <td>
                  <div>
                    {{ lancs[0].forma_pagamento.search }}
                    <span class="text-muted ml-2" v-if="lancs[0].item_pagamento_atendimento.in_parcelas > 1">
                      x{{ lancs[0].item_pagamento_atendimento.in_parcelas }}
                    </span>
                    <span v-for="(lanc, ilcx) in lancs" :key="ilcx">
                      <div v-show="lanc.arquivos.length">
                        #{{ lanc.id_lancamento }}
                        <i class="fa fa-caret-right ml-1 mr-2" aria-hidden="true"></i>
                        <a href="#" @click.prevent="ver_anexos(lanc.id_lancamento)" class="card-link" :title="lanc.arquivos.length + ' arquivo(s) anexados.'">
                          <i class="fa fa-paperclip" aria-hidden="true"></i>
                        </a>
                      </div>
                    </span>

                    <div v-if="lancs[0].item_pagamento_atendimento.estorno" class="text-muted">
                        Motivo: {{ lancs[0].item_pagamento_atendimento.estorno.st_motivo }}
                        <div v-if="lancs[0].item_pagamento_atendimento.estorno.usuario_solic">
                            Por: {{ lancs[0].item_pagamento_atendimento.estorno.usuario_solic.st_login }}
                        </div>
                    </div>

                    <div>
                        <span class="badge badge-warning mr-1" v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.item_pagamento_atendimento_pendentes && lancs[0].item_pagamento_atendimento.pagamento_atendimento.item_pagamento_atendimento_pendentes.length">
                            Pendente: {{ $util.formatMoeda(lancs[0].item_pagamento_atendimento.pagamento_atendimento.item_pagamento_atendimento_pendentes.reduce((acc, item) => acc + item.dc_valor, 0)) }}
                        </span>

                        <span class="badge badge-info mr-1" v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.desconto">
                            Desconto: {{ $util.formatMoeda(lancs[0].item_pagamento_atendimento.pagamento_atendimento.desconto.dc_valor) }}
                        </span>
                    </div>
                  </div>
                  <span class="text-muted" v-if="lancs[0].bandeira_cartao">
                    {{ lancs[0].bandeira_cartao.search }}
                    <span v-if="lancs[0].item_pagamento_atendimento.st_autorizacao"> / {{ lancs[0].item_pagamento_atendimento.st_autorizacao }}</span>
                  </span>
                  <span class="text-muted" v-else-if="lancs[0].item_pagamento_atendimento && lancs[0].item_pagamento_atendimento.st_autorizacao">
                    {{ lancs[0].item_pagamento_atendimento.st_autorizacao }}
                  </span>
                </td>

                <!-- Profissional  -->
                <td>
                  <span v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento">
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.medico.search }}
                  </span>
                  <span v-else-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.medico" class="text-muted">
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.medico.search }}
                  </span>

                  <div v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.procedimento" title="Procedimento." class="small text-muted">
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.procedimento.search }}
                  </div>
                </td>

                <!-- Responsável -->
                <td v-if="tipo_quebra != 'U'">
                  {{ lancs[0].usuario.st_login }}
                </td>

                <!-- Recibo -->
                <td>
                  <!-- Edição do Pagamento quando no financeiro -->
                  <div  v-if="!fechamento_recepcao">
                    <a href="#" class="card-link" @click.prevent="abrir_pagamento(lancs[0].item_pagamento_atendimento.id_pagamento_atendimento)">
                      {{ lancs[0].item_pagamento_atendimento.id_pagamento_atendimento }}
                    </a>
                  </div>
                  <div v-else>
                    {{ lancs[0].item_pagamento_atendimento.id_pagamento_atendimento }}
                  </div>
                  <div class="small text-muted" v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.st_id_externo" title="Pagamento">
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.st_id_externo }}
                  </div>
                  <!--Número do Orçamento -->
                  <div v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.orcamentos &&
                            lancs[0].item_pagamento_atendimento.pagamento_atendimento.orcamentos.length" title="Orçamento"
                            class="text-muted">
                    OR: {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.orcamentos.map(item => '#' + item.id_orcamento).join(", ") }}
                  </div>
                  <div title="Orçamento" class="text-muted"
                    v-else-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento
                      && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao
                      && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.id_orcamento">
                    OR: #{{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.id_orcamento }}
                  </div>
                  <div v-if="dados && dados.zoop && zoop_info(lancs[0], 'transaction_id')" class="text-muted">
                    Zoop: {{ zoop_info(lancs[0], 'transaction_id') }} 

                    <a href="#" @click.prevent="validar_split_zoop(lancs[0])" class="card-link ml-2 text-primary" v-if="split_zoop == 'S'" title="Visualizar Splits Previstos">
                        <i class="fa-solid fa-split"></i>
                    </a>

                    <a href="#" @click.prevent="validar_split_zoop(lancs[0])" class="card-link ml-2 text-primary" title="Visualizar Splits" v-else-if="split_zoop == 'R'">
                        <i class="fa-solid fa-octagon-divide"></i>
                    </a>
                  </div>
                </td>
                <td>
                  <template v-if="lancs[0].item_pagamento_atendimento.nota_fiscal_links && Array.isArray(lancs[0].item_pagamento_atendimento.nota_fiscal_links) && lancs[0].item_pagamento_atendimento.nota_fiscal_links.length > 0">
                    <template v-for="(nfl, nf_idx) in lancs[0].item_pagamento_atendimento.nota_fiscal_links">
                        <br v-if="nf_idx > 0" :key="'A' + nf_idx"/>
                        <span v-if="nfl.nota_fiscal_servico" :class="getNFStatusClass(nfl.nota_fiscal_servico.ch_status)" :key="nf_idx">
                          <!-- {{ nfl.nota_fiscal_servico.st_numero + ' - ' + getNFStatusDesc(nfl.nota_fiscal_servico.ch_status) }} -->
                          {{ nfl.nota_fiscal_servico.search }}
                        </span>
                        <div class="mr-5 mt-1 small text-danger"
                            :key="'ER' + nf_idx"
                            v-if="nfl.nota_fiscal_servico.st_erro && nfl.nota_fiscal_servico.ch_erro_emissao != '0' && nfl.nota_fiscal_servico.ch_status == '1'">
                            Erro: {{ nfl.nota_fiscal_servico.st_erro }}
                        </div>
                    </template>
                  </template>
                  <template v-else>
                    {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.st_numero_nf }}
                    <span v-if="lancs[0].item_pagamento_atendimento.pagamento_atendimento.st_chave_acesso">
                        <br />
                        <small class="text-muted">
                            {{ lancs[0].item_pagamento_atendimento.pagamento_atendimento.st_chave_acesso }}
                        </small>
                    </span>
                  </template>
                </td>
                <td class="lead text-success text-right">
                  <span v-if="lancs.length > 1" class="badge badge-secondary mr-2">
                    {{ lancs.length }}
                  </span>
                  {{ $util.formatMoeda(total_valor(lancs, true)) }}
                  <div v-if="lancs[0] && lancs[0].item_pagamento_atendimento && lancs[0].item_pagamento_atendimento.splits && lancs[0].item_pagamento_atendimento.splits.length">
                    <template v-for="(split, isx) in lancs[0].item_pagamento_atendimento.splits">
                        <div v-if="split.id_forma_pagamento == 95" :key="isx" class="small text-muted">
                            <i class="fa-solid fa-octagon-divide"></i>
                            {{ $util.formatMoeda(split.dc_valor) }}
                        </div>
                    </template>
                  </div>
                </td>
                <td class="text-nowrap text-center">
                  <a href="#" @click.prevent="reativar_cancelado(lancs[0])" v-if="lancs[0].ch_estado == 'C'" :title="'#' + lancs[0].id_lancamento">
                    <span class="badge badge-danger">Cancelado</span>
                  </a>
                  <input type="checkbox" v-model="lancs[0].selecionado" v-else-if="filtro.status && filtro.status != 'PF'" @input="marcar_itens(lancs, lancs[0].selecionado)" :disabled="lancs[0].forma_pagamento && lancs[0].forma_pagamento.fl_repasse_devol">
                  <span v-else>
                    <i class="fa fa-check-circle text-success fa-2x" aria-hidden="true" v-if="lancs[0].ch_estado == 'A'" title="Recebido"></i>
                    <i class="fa fa-circle text-muted fa-2x" aria-hidden="true" v-if="lancs[0].ch_estado == 'P'" title="A Enviar/Receber"></i>
                    <i class="fas fa-stop-circle text-info fa-2x" aria-hidden="true" v-if="lancs[0].ch_estado == 'F'" title="Fechado"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

      </div>

      <nav class="navbar fixed-bottom navbar-light bg-light" v-if="selecionados && selecionados.length > 0">

        <div class="navbar-brand">
          Total Selecionado: {{ $util.formatMoeda (total_selecionado) }}
        </div>

        <!-- Recepção -->
        <div class='mr-3' v-if="fechamento_recepcao">
          <az-submit @click="abrir_receber ()" v-if="filtro.status == 'P'">
            Confirmar Fechamento
          </az-submit>

          <az-submit color="outline-danger" @click="cancelar_recebimento ()" v-if="filtro.status == 'F'">
            Cancelar Fechamento
          </az-submit>
        </div>

        <!-- Financeiro -->
        <div class='mr-3' v-if="!fechamento_recepcao">
            <az-submit class="mr-2" color="outline-primary" @click="gerar_split_zoop ()" v-if="dados && dados.zoop && dados.split_zoop">
                Gerar Split Zoop
            </az-submit>

            <div class="btn-group dropup mr-2">
              <button class="btn btn-outline-primary dropdown-toggle" type="button" id="notasFiscaisDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Notas Fiscais
              </button>
              <div class="dropdown-menu" aria-labelledby="notasFiscaisDropdown">
                <a class="dropdown-item" href="#" @click.prevent="gerar_nfs_lote()">
                  <i class="fa fa-wifi text-primary mr-2" aria-hidden="true"></i>Gerar Notas Fiscais
                </a>
                <a class="dropdown-item" href="#" @click.prevent="cancelar_nfs_lote()">
                  <i class="fa fa-wifi text-danger mr-2" aria-hidden="true"></i>Cancelar Notas Fiscais (Geradas)
                </a>
                <a class="dropdown-item" href="#" @click.prevent="emitir_nfs_lote()">
                  <i class="fa fa-wifi text-success mr-2" aria-hidden="true"></i>Emitir Notas Fiscais
                </a>
                <a class="dropdown-item" href="#" @click.prevent="consultar_nfs_lote()">
                  <i class="fa fa-wifi text-info mr-2" aria-hidden="true"></i>Consultar Notas Fiscais
                </a>
              </div>
            </div>

            <az-submit @click="abrir_receber ()" v-if="filtro.status == 'P' || filtro.status == 'F'">
                Confirmar Recebimento
            </az-submit>

            <az-submit color="danger" @click="cancelar_recebimento ()" v-if="filtro.status == 'A'">
                Cancelar Recebimento
            </az-submit>
        </div>

      </nav>

      <pre v-if="1 == 0" class="alert alert-info">{{ usuarios }}</pre>
    </div>

    <!-- Informações da Conta Caixa -->

      <div v-if="fechamento_recepcao && dados && dados.conta && filtro.status == 'F'">

        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between active">
            <div>{{ dados.conta.st_conta }}</div>
            <div>
              <button type="button" class="btn btn-sm btn-outline-light" @click="incluir_lancamento()">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <div>Saldo Inicial do Dia</div>
            <div>
              {{ $util.formatMoeda(dados.saldo) }}
              <i class="fa fa-circle text-primary ml-2" aria-hidden="true"></i>
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between" v-for="(baixa, ibx) in dados.baixas" :key="'B' + ibx">
            <div>
              {{ baixa.lancamento.st_descricao }}
              <small class="text-muted ml-2">
                {{ baixa.lancamento.categoria ? baixa.lancamento.categoria.search : '.' }}
              </small>
            </div>
            <div>
              {{ $util.formatMoeda(baixa.valor_liquido) }}
              <i class="fa fa-plus-circle text-success ml-2" aria-hidden="true" v-if="baixa.fator > 0"></i>
              <i class="fa fa-minus-circle text-danger ml-2" aria-hidden="true" v-if="baixa.fator < 0"></i>
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <div>Lançamentos</div>
            <div>
              {{ $util.formatMoeda (total) }}
              <i class="fa fa-plus-circle text-success ml-2" aria-hidden="true"></i>
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <div>Saldo Final</div>
            <div>
              {{ $util.formatMoeda (dados.saldo + total + total_baixas) }}
              <i class="fa fa-circle text-primary ml-2" aria-hidden="true"></i>
            </div>
          </li>
        </ul>
      </div>

    <!-- Modal -->
    <div class="modal fade" id="recebimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ fechamento_recepcao ? 'Fechamento' : 'Recebimento' }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <label class="form form-control">Total Selecionado: {{ $util.formatMoeda (total_selecionado) }}</label>
            <div class="row">
              <div class="col col-12" v-if="!fechamento_recepcao">
                <az-input
                  type="checkbox-group"
                  label="Realizar Baixa"
                  v-model="info_baixa" />
              </div>
            </div>
            <template v-if="info_baixa">
              <div class="row">
                <div class="col col-12">
                  <az-input
                    type="date"
                    label="Data"
                    :validate="validate"
                    required
                    v-model="baixa.dt_baixa" />
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <az-input
                    label="Conta"
                    :validate="validate"
                    type="select"
                    optionsMode="aql"
                    service="contas.index"
                    optionsData="id_conta"
                    optionsDisplay="search"
                    :optionsParm="{ ativas: true }"
                    required
                    v-model="baixa.id_conta" />
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <az-input
                    label="Observação"
                    :validate="validate"
                    v-model="baixa.st_observacoes" />
                </div>
              </div>
              <div class="row mt-2">
                <div class="col col-12">
                  <az-input
                    label="Baixa Unificada"
                    :validate="validate"
                    type="checkbox-group"
                    v-model="baixa.unificada" />
                </div>
              </div>
              <div class="row mt-2" v-if="baixa.unificada">
                <div class="col col-12">
                  <az-input
                    label="Descrição"
                    placeholder="Informar..."
                    required
                    :validate="validate"
                    v-model="baixa.st_descricao" />
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="receber()">Confirmar {{ fechamento_recepcao ? 'Fechamento' : 'Recebimento' }}</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginação -->
    <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.lancamentos && ( dados.lancamentos.last_page > 1 || ( !dados.lancamentos.last_page && dados.lancamentos.to >= dados.lancamentos.per_page ) )">
        <div class="d-flex">
            <paginate
                class="mb-0"
                :page-count="dados.lancamentos.last_page ? dados.lancamentos.last_page : ( dados.lancamentos.current_page + 1 )"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :prev-text="'<<'"
                :next-text="'>>'"
                :click-handler="paginar">
            </paginate>
        </div>
    </nav>

    <edicao-lancamento ref="lancamento" @refresh="load()" :unidade="unidade" :fechamento="true" />

    <!-- Dispatch -->
    <az-dispatch ref="dispatchModal" titulo="Emitir Nfs em Lote" @refresh="load()" />

    <!-- Ver Aenxos -->
    <view-anexos ref="anexos" />

    <!-- Edição do Pagamento -->
    <div class="modal fade" id="pagamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog2" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pagamento</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <pagamento ref="pag" @refresh="load()">
                <div v-if="1==0" class="mt-3 alert alert-info d-flex justify-content-between">
                    <div>
                        Orçamento: 
                        <a href="#" @click.prevent="abrir_orcamento(dados.orcamento)" class="card-link">
                            #{{ dados.orcamento.id_orcamento }}
                        </a>
                    </div>
                    <div> 
                        R$ {{ $util.formatMoeda(dados.orcamento.valor_final) }}
                    </div>
                </div>
            </pagamento>
                
            <!--
                <az-submit @click="salvar_pagamento()">Registrar</az-submit>
                <button type="button" class="btn btn-secondary ml-2" @click="novo = null">
                    Voltar
                </button>
                <button type="button" class="btn btn-outline-primary ml-2" @click="abrir_recibo()">
                    Recibo
                </button>
            -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="salvar_pagamento()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dados && dados.pago_adiantamentos && dados.pago_adiantamentos.data && dados.pago_adiantamentos.data.length">

      <div class="small text-muted">Pagos com Uso de Adiantamento</div>
      <table class="table table-hover small bg-white">
        <thead>
          <tr>
            <th>Atendimento</th>
            <th>Und</th>
            <th>Paciente</th>
            <th>Recibo</th>
            <th>NF</th>
            <th class="text-right">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(uso, iux) in dados.pago_adiantamentos.data" :key="iux">
            <td>
              <div>
                {{ $util.getFormatDate(uso.atendimento.dt_inicio) }}
              </div>
              <a href="#" @click.prevent="abrir_atendimento(uso.atendimento.id_atendimento)" class="card-link">
                #{{ uso.atendimento.id_atendimento }}
              </a>
            </td>
            <td>
              <span class="badge badge-light" v-if="uso.atendimento.marcacao && uso.atendimento.marcacao.unidade_operacao">{{ uso.atendimento.marcacao.unidade_operacao.st_sigla }}</span>
            </td>
            <td>
              <span v-if="uso.paciente">{{ uso.paciente.st_nome }}</span>
              <span v-else-if="uso.atendimento && uso.atendimento.paciente">{{ uso.atendimento.paciente.st_nome }}</span>
            </td>
            <td>
              <div>
                {{ uso.item_pagamento_atendimentos.map(item => item.id_pagamento_atendimento).join(", ") }}
              </div>
              <!--Número do Orçamento -->
              <div v-if="uso.atendimento.marcacao && uso.atendimento.marcacao.id_orcamento" title="Orçamento" class="text-muted">
                OR: {{ uso.atendimento.marcacao.id_orcamento }}
              </div>
            </td>
            <td>
                <template v-if="uso.item_pagamento_atendimentos[0] && uso.item_pagamento_atendimentos[0].nota_fiscal_links && Array.isArray(uso.item_pagamento_atendimentos[0].nota_fiscal_links) && uso.item_pagamento_atendimentos[0].nota_fiscal_links.length > 0">
                    <template v-for="(nfl, nf_idx) in uso.item_pagamento_atendimentos[0].nota_fiscal_links">
                        <br v-if="nf_idx > 0" :key="'A' + nf_idx"/>
                        <span v-if="nfl.nota_fiscal_servico" :class="getNFStatusClass(nfl.nota_fiscal_servico.ch_status)" :key="nf_idx">
                          {{ nfl.nota_fiscal_servico.st_numero + ' - ' + getNFStatusDesc(nfl.nota_fiscal_servico.ch_status) }}
                        </span>
                        <div class="mr-5 mt-1 small text-danger"
                            :key="'ER' + nf_idx"
                            v-if="nfl.nota_fiscal_servico.st_erro && nfl.nota_fiscal_servico.ch_erro_emissao != '0' && nfl.nota_fiscal_servico.ch_status == '1'">
                            Erro: {{ nfl.nota_fiscal_servico.st_erro }}
                        </div>
                    </template>
                </template>
            </td>
            <td class="text-right">{{ $util.formatMoeda(total_valor(uso.item_pagamento_atendimentos)) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">Total</td>
            <td class="text-right">{{ $util.formatMoeda(total_pago_adiantamento) }}</td>
          </tr>
          <td colspan="5"><strong>Total Geral</strong></td>
            <td class="text-right"><strong>{{ $util.formatMoeda(total + total_pago_adiantamento) }}</strong></td>
        </tfoot>
      </table>

      <br><br><br><br><br>

      <pre v-if="false">Pagos: {{ dados.pago_adiantamentos }}</pre>
    </div>

    <!-- Modal Observação Cancelamento -->
    <div class="modal fade" id="fechamentoCancelamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Cancelar</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-input
                        label="Motivo do Cancelamento"
                        type="textarea"
                        rows="3"
                        v-model="obs_cancelamento"
                        required
                        :validate="validate" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit color="danger" @click="cancelar_recebimento(true)">Realizar Cancelamento</az-submit>
                </div>
            </div>
        </div>
    </div>

    <ver-fechamentos-particulares ref="fechamentos" />

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar">
      <az-file-upload
        ref="upload"
        @refresh="carregar_arquivos()"
        :multiple="true"
        :arquivos="marcacao.arquivos"
        :parms="{ 
          model_type: marcacao.id_marcacao ? 'marcacao' : ( marcacao.id_cadastro_temporario ? 'cadastroTemporario' : 'pessoa' ), 
          model_id: marcacao.id_marcacao ? marcacao.id_marcacao : ( marcacao.id_cadastro_temporario ? marcacao.id_cadastro_temporario : marcacao.id_pessoa ), 
          id_paciente: marcacao.id_paciente ? marcacao.id_paciente : marcacao.id_pessoa,
          tipo_especial: marcacao.id_marcacao ? null : 'anexo', 
        }" />
    </template>

    <br><br><br><br><br><br>

    <zoop-split-modal ref="zoop" />

  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import PrintExport from '../../shared/PrintExport.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzDispatch from "../../util/AzDispatch.vue";
import ViewAnexos from '../../shared/gallery/ViewAnexos.vue';
import Pagamento from '../recepcao/Pagamento.vue';
import VerFechamentosParticulares from './VerFechamentosParticulares.vue'
import AzFileUpload from '../../util/AzFileUpload.vue';
import ZoopSplitModal from './ZoopSplitModal.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';
import TableTh from '../../shared/table/TableTh.vue';

export default {
  data() {
    return {
      dados: null,
      referencia: this.$util.hoje().substr(0,7),
      from: "",
      to: "",
      por_usuario: true,
      filtro: {
        natureza: "",
        status: "P",
        periodo: "do",
        inicio: "",
        fim: "",
        id_medico: "", 
        tipo_data: "", 
        status_nf: "", 
      },
      id_usuario: "",
      id_forma_pagamento: "",
      search: "",
      id_unidade_operacao: "",
      id_recepcao: "", 
      id_plano: "",
      info_baixa: false,
      baixa: {
        dt_baixa: this.$util.hoje(),
        id_conta: "",
        unificada: false,
        st_descricao: "",
      },
      montando: true,
      unidade: "",
      validate: false,
      paciente: "",
      page: 1,
      tipo_quebra: "U", 
      pago_para: "", 
      show_pendentes: false, 
      show_fechamentos: false, 
      marcacao: null, 
      acao_anexar: false,
      split_zoop: false, 
      split_zoop_valid: null, 
      obs_cancelamento: "", 
      ordem: "", 
    };
  },

  components: {
    AzInput,
    AzEmptyState,
    AzSubmit,
    PrintExport,
    EdicaoLancamento,
    AzPeriodo,
    AzDispatch,
    ViewAnexos,
    Pagamento, 
    VerFechamentosParticulares, 
    AzFileUpload,
    ZoopSplitModal,
    RelatoriosLinkados,
    TableTh,
  },

  props: ['tipo'], 

  computed: {
    lista_recepcoes: function () { 
        if ( !this.id_unidade_operacao ) { 
            return [];
        }

        let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

        if ( unid ) { 
            return unid.recepcaos;
        } else { 
            return [];
        }
    },
    total_pago_adiantamento: function () { 
      if ( !this.dados || !this.dados.pago_adiantamentos || !this.dados.pago_adiantamentos.data ) { 
        return 0;
      }

      return this.dados.pago_adiantamentos.data.reduce((total, carry) => { 
          if ( !carry || !carry.item_pagamento_atendimentos )
            return total;

          return total + ( this.total_valor(carry.item_pagamento_atendimentos) );
        }, 0);
    },

    fechamento_recepcao: function () {
      return this.$route.meta.recepcao ? true : false;
    },

    fechamento_geral: function () {
      return ( this.dados && this.dados.geral ) ? true : false;
    },

    dadosFormatados: function () {

      let agrupada = this.lista_agrupada(this.lista);

      let lista = _.map(agrupada, lancs => {

        let ors = ''; 

        if ( lancs[0].item_pagamento_atendimento.pagamento_atendimento.orcamentos &&
              lancs[0].item_pagamento_atendimento.pagamento_atendimento.orcamentos.length ) { 

          ors = lancs[0].item_pagamento_atendimento.pagamento_atendimento.orcamentos.map(item => '#' + item.id_orcamento).join(", ");

        } else if ( lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento
          && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao
          && lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.id_orcamento ) { 

          ors = lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.marcacao.id_orcamento;

        }

        return {
          data: this.$util.getFormatDate(lancs[0].dt_emissao),
          paciente: lancs[0].item_pagamento_atendimento.pagamento_atendimento.nome_paciente,
          formaDePagamento: lancs[0].forma_pagamento.search,
          cartao: lancs[0].bandeira_cartao ? ( lancs[0].bandeira_cartao.search + ' / ' + lancs[0].item_pagamento_atendimento.st_autorizacao ) : '',
          profissional: lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento
            ? lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.medico.search
            : '',
          responsavel: lancs[0].usuario.st_login,
          valor: this.$util.formatMoeda(_.sumBy(lancs, 'dc_valor')),
          recibo: lancs[0].item_pagamento_atendimento.id_pagamento_atendimento,
          nf: (lancs[0].item_pagamento_atendimento.nota_fiscal_links && Array.isArray(lancs[0].item_pagamento_atendimento.nota_fiscal_links) && lancs[0].item_pagamento_atendimento.nota_fiscal_links.length > 0)
            ? lancs[0].item_pagamento_atendimento.nota_fiscal_links.map(nf => nf.nota_fiscal_servico ? nf.nota_fiscal_servico.st_numero + ' - ' + this.getNFStatusDesc(nf.nota_fiscal_servico.ch_status) : '').join(', ')
            : lancs[0].item_pagamento_atendimento.pagamento_atendimento.st_numero_nf,
          parcelas: lancs[0].item_pagamento_atendimento.in_parcelas,
          atendimento: lancs[0].item_pagamento_atendimento.pagamento_atendimento.id_atendimento 
            ? '#' + lancs[0].item_pagamento_atendimento.pagamento_atendimento.id_atendimento
            : '',
          adiantamento: lancs[0].item_pagamento_atendimento.pagamento_atendimento.dc_valor_adiantado > 0 ? 'S' : 'N',
          id_orcamento: ors,
          pendente: ( lancs[0].item_pagamento_atendimento.pagamento_atendimento.item_pagamento_atendimento_pendentes && lancs[0].item_pagamento_atendimento.pagamento_atendimento.item_pagamento_atendimento_pendentes.length )
            ? this.$util.formatMoeda(lancs[0].item_pagamento_atendimento.pagamento_atendimento.item_pagamento_atendimento_pendentes.reduce((acc, item) => acc + item.dc_valor, 0))
            : 0,
          desconto: lancs[0].item_pagamento_atendimento.pagamento_atendimento.desconto
            ? this.$util.formatMoeda(lancs[0].item_pagamento_atendimento.pagamento_atendimento.desconto.dc_valor)
            : 0, 
        };
        
      });

      return lista;

    },

    status: function () {
      return this.filtro.status;
    },

    usuarios: function () {
      if ( !this.dados )
        return [];

      return _.sortBy(
        _.unionBy(
          this.dados.lancamentos.data.map(item => { return { ...item.usuario } }),
          (item) => item.id_usuario
        ),
        'search'
      );
    },

    lista: function () {
      if ( !this.dados )
        return [];

      let reg = this.$util.getregex(this.search);

      return _.orderBy(
        this.dados.lancamentos.data.filter(item => {
          return ( item.id_categoria ) &&
            ( !this.id_forma_pagamento || item.id_forma_pagamento == this.id_forma_pagamento ) &&
            ( !this.id_usuario || item.id_usuario == this.id_usuario ) &&
            ( !this.filtro.status || this.filtro.status.split('').find(status => status == item.ch_estado) ) &&
            ( !this.search || reg.test(JSON.stringify(item)) );
        }),
        'dt_emissao'
      );
    },

    total: function () {
        return _.reduce(
            _.groupBy(this.lista, 'id_item_pagamento_atendimento'), 
            (total, carry) => { 
                return total + this.total_valor(carry, true);
            }, 
            0
        );
    },

    adiantamentos: function () {
      return _.sumBy(
        this.lista.filter(lanc => lanc.item_pagamento_atendimento.pagamento_atendimento.dc_valor_adiantado),
        'dc_valor'
      );
    },

    total_baixas: function () {
      if ( !this.dados || !this.dados.baixas )
        return 0;

      return this.dados.baixas.reduce((total, carry) => total + ( carry.valor_liquido * carry.fator ), 0);
    },

    consolidado: function () {
      let resultado = _.groupBy(this.lista, (item) => {
        return item.forma_pagamento ? item.forma_pagamento.search : '?';
      });

      resultado = _.mapValues(resultado, (items) => {
        return _.reduce(
            _.groupBy(items, 'id_item_pagamento_atendimento'), 
            (total, carry) => { 
                return total + this.total_valor(carry, true);
            }, 
            0
        );
      });

      return resultado;

    },

    lista_por_usuario: function () {
      return _.groupBy(this.lista, item => { 
        switch (this.tipo_quebra) {
          case 'U':
            return item.usuario.search;
          case 'F':
            return item.forma_pagamento ? item.forma_pagamento.search : '?';
        }

        return 'Geral';
      });
    },

    total_usuarios: function () {
      return _.uniqBy(this.lista, 'usuario.search').length;
    },

    selecionados: function () {
      return this.lista.filter(item => item.selecionado);
    },

    total_selecionado: function () {
      return this.selecionados.reduce((total, item) => {
        return total = total + item.dc_valor;
      }, 0);
    }

  },

  watch: {
    filtro: {
        handler: function () {
          //this.dados = null;
          //this.load();
        },
        immediate: true,
        deep: true,
    },

    status: function () {
      //this.dados = null;
      //this.load ();
    },

    id_unidade_operacao: function () {
      //this.dados = null;
      //this.load ();
    }
  },

  methods: {
    zoop_info(lanc, info) { 
        if ( !this.dados || !this.dados.zoop ) { 
            return; 
        }

        return _.get(lanc, 'item_pagamento_atendimento.js_outros.zoop.' + info, _.get(lanc, 'item_pagamento_atendimento.zoop_' + info));
    }, 

    gerar_split_zoop () { 
        if ( !confirm('Confirma gerar o split de pagamento para os itens selecionados?') )
            return;

        this.$util.atualizar(this, {
            service: 'financeiro',
            func: 'gerar_split_zoop',
            dados: {
                lista: _.uniq(this.selecionados.map(item => _.get(item, 'item_pagamento_atendimento.id_item_pagamento_atendimento')).filter(item => item)),
            },
            toast: true,
            reload: true,
        });
    },

    ver_splits (lanc) { 
        console.log('teste', _.cloneDeep(lanc));
        this.$refs.zoop.ver_splits(lanc);
    },

    validar_split_zoop (lanc) { 

        this.$refs.zoop.abrir(lanc);

        /*
        this.split_zoop_valid = null; 

        $('#zoopModal').modal('show');

        this.$util.atualizar(this, {
            service: 'financeiro',
            func: 'gerar_split_zoop',
            dados: {
                lista: [
                    lanc.item_pagamento_atendimento.id_item_pagamento_atendimento
                ],
                valid: true, 
            },
            reload: true,
            callback: res => { 
                this.split_zoop_valid = { 
                    ...res,
                    ipa: lanc.item_pagamento_atendimento
                };
            }
        });
        */

    },


    abrir_anexar_arquivo(marcacao) {
      this.marcacao = marcacao;
      this.acao_anexar = true;

      this.carregar_arquivos(true);
    },

    carregar_arquivos (abrir = false) {

      this.$store.commit('loading', true);

      if ( this.marcacao.id_marcacao ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_marcacao,
            type: 'marcacao',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else if ( this.marcacao.id_cadastro_temporario ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_cadastro_temporario,
            type: 'cadastroTemporario',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_pessoa,
            type: 'pessoa',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });


      }

    },

    ver_fechamentos (lancs) { 
      this.$refs.fechamentos.abrir(lancs);
    },

    buscar_fechamento (fechamento) { 
      if ( this.search == "F" + fechamento.id_fechamento_particular ) { 
        this.search = "";
      } else {
        this.search = "F" + fechamento.id_fechamento_particular;
      }
      
      this.load();
    },

    totalizar_pendentes (lista) { 
      return _.reduce(
        lista, 
        (total, carry) => { 
          if ( carry.pagamento_atendimento && carry.pagamento_atendimento.item_pagamento_atendimentos && carry.pagamento_atendimento.item_pagamento_atendimentos.length ) { 
            total = total + this.totalizar(carry.pagamento_atendimento.item_pagamento_atendimentos, 'dc_valor');
          } else if ( carry.valor_extra > 0 ) { 
            total = total + parseFloat(carry.valor_extra);
          } else { 
            total = total + this.totalizar(carry.atendimento_procedimentos, 'cd_valor_total');
          }

          return total;
        },
        0
      );
    },

    totalizar(lista, campo) { 
      return _.sumBy(lista, campo);
    },

    abrir_pagamento (id) { 
      this.$refs.pag.abrir_pagamento(id);
      $('#pagamentoModal').modal('show');
    },

    salvar_pagamento() { 
      this.$refs.pag.atualizar(
        () => {
          $('#pagamentoModal').modal('hide');
        },
        () => {
          this.load();
        }
      );
    },

    paginar (page) {
        this.page = page;
        this.load(page);
    },

    ver_anexos (id) {
      this.$refs.anexos.abrir('lancamento', id);
    },

    abrir_atendimento(id_atendimento) {
      this.$util.abrir_atendimento(this, id_atendimento);
    },

    reativar_cancelado (lancamento) {
      if ( this.$store.state.loading )
        return;

      if ( this.$route.path.substr(0,11) != '/financeiro' ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: 'Reativação de lançamento cancelado, somente no financeiro.',
          life: 3000
        });
        return;
      }

      if ( !confirm('Deseja reativar o lançamento cancelado?') )
        return;

      this.$util.atualizar(this, {
        service: 'financeiro',
        func: 'reativar_lancamento',
        dados: {
          id_lancamento: lancamento.id_lancamento,
        },
        toast: true,
        reload: true,
      });
    },

    getNFStatusClass: function(status) {
        switch (status) {
            case "1":
                return "text-info";
            case "2":
                return "text-primary";
            case "3":
                return "text-warning";
            case "4":
                return "text-success";
            case "5":
                return "text-danger";

            default:
                return "text-info";
        }
    },
    getNFStatusDesc: function(status) {
        switch (status) {
            case "1":
                return "Gerada";
            case "2":
                return "Não Processada";
            case "3":
                return "Processado com Erro";
            case "4":
                return "Emitida";
            case "5":
                return "Cancelada";

            default:
                return "";
        }
    },
    marcar_itens(lista, marcado) {
      _.each(lista, item => {
        item.selecionado = !marcado;
      });
    },

    total_valor(lancs, sum_splits = false, sum_from_lista = false) {
        if ( sum_splits && sum_from_lista) { 
            return _.reduce(
                _.groupBy(lancs, 'id_item_pagamento_atendimento'), 
                (total, carry) => { 
                    return total + this.total_valor(carry, true);
                }, 
                0
            );
        }

        return lancs.reduce((total, carry, index) => {
            let splits = 0; 

            if ( sum_splits && !index ) { 
                splits = ( carry.item_pagamento_atendimento && carry.item_pagamento_atendimento.splits && carry.item_pagamento_atendimento.splits.length ) 
                    ? carry.item_pagamento_atendimento.splits.reduce((sum, split) => sum + (split.id_forma_pagamento == 95 ? split.dc_valor : 0), 0) 
                    : 0;
            }

            return total + carry.dc_valor + splits;
        }, 0);
    },

    lista_agrupada (lista) {
        if ( this.ordem && ( this.ordem.name == 'total_valor' ) ) { 
            
            let agrupada = _.groupBy(lista, item => { 
                return '#' + item.id_item_pagamento_atendimento;
            });

            agrupada = _.orderBy(
                agrupada, 
                (lancs) => { 
                    return this.total_valor(lancs, true);
                },
                this.ordem.direction == 'desc' ? 'desc' : 'asc'
            );

            return agrupada; 

        } else if ( this.ordem && ( this.ordem.name == 'profissional' ) ) { 

            let agrupada = _.groupBy(lista, item => { 
                return '#' + item.id_item_pagamento_atendimento;
            });

            agrupada = _.orderBy(
                agrupada, 
                (lancs) => { 
                    if ( lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento ) { 
                        return lancs[0].item_pagamento_atendimento.pagamento_atendimento.atendimento.medico.search; 
                    } else if ( lancs[0].item_pagamento_atendimento.pagamento_atendimento.medico ) { 
                        return lancs[0].item_pagamento_atendimento.pagamento_atendimento.medico.search; 
                    } else { 
                        return '';
                    }
                },
                this.ordem.direction == 'desc' ? 'desc' : 'asc'
            );

            return agrupada; 

        } else if ( this.ordem ) { 
            
            lista = _.orderBy(
                lista, 
                (item) => { 
                    return _.get(item, this.ordem.name );
                },
                this.ordem.direction == 'desc' ? 'desc' : 'asc'
            );

        }
         
        return _.groupBy(lista, item => { 
            return '#' + item.id_item_pagamento_atendimento;
        });
    },

    ajustar_fim () {
        if ( this.from )
            this.to = this.from;
    },

    incluir_lancamento () {
      this.$refs.lancamento.incluir(true, this.dados.conta.id_conta);
    },

    cache_tipo_quebra() {
      this.$util.setCookie('presta-por-user', this.tipo_quebra);
    },

    marcarTodos(items) {

      let marcar = ( items.findIndex(item => !item.selecionado) >= 0 ) ;

      items.filter(element => !element.forma_pagamento || !element.forma_pagamento.fl_repasse_devol)
        .forEach(element => {
          element.selecionado = marcar;
        });
    },

    consolidar (lista, sum_splits = false) {

      let resultado = _.groupBy(lista, (item) => {
        return item.forma_pagamento ? item.forma_pagamento.search : '?';
      });

      resultado = _.mapValues(resultado, (items) => {
        return _.reduce(
            _.groupBy(items, 'id_item_pagamento_atendimento'), 
            (total, carry) => { 
                return total + this.total_valor(carry, sum_splits);
            }, 
            0
        );
      });

      return resultado;

    },

    gerar_nfs_lote() {
      let id_pags = [];

      this.selecionados.forEach(item => {
        const pagamento = item.item_pagamento_atendimento;
        const notas = pagamento && Array.isArray(pagamento.nota_fiscal_links)
          ? pagamento.nota_fiscal_links
          : [];
        const semNota = !notas.length;
        const notaCancelada = notas.some(nota =>
          nota.nota_fiscal_servico && nota.nota_fiscal_servico.ch_status == '5'
        );

        if ( pagamento && (semNota || notaCancelada) ) {
          id_pags.push(pagamento.id_pagamento_atendimento);
        }
      });

      id_pags = _.uniq(id_pags);

      if ( !id_pags.length ) {
        this.$toast.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Selecione pagamentos sem nota fiscal ou com nota fiscal cancelada.',
          life: 3000
        });
        return;
      }

      if ( !confirm('Deseja realmente gerar as Notas Fiscais selecionadas?') ) {
        return;
      }

      this.$util.atualizar(this, {
        service: 'nota_fiscal_servico',
        func: 'gerar_nf_pagamento_atendimentos_lote',
        redir_api: true,
        toast: true,
        dados: {
          id_pagamento_atendimentos: id_pags
        },
        callback: () => {
          this.load();
        }
      });

    },

    cancelar_nfs_lote() {
      let id_nfs = [];

      this.selecionados.forEach(item => {
        const pagamento = item.item_pagamento_atendimento;
        const notas = pagamento && Array.isArray(pagamento.nota_fiscal_links)
          ? pagamento.nota_fiscal_links
          : [];

        notas.forEach(nota => {
          if ( nota.nota_fiscal_servico && nota.nota_fiscal_servico.ch_status == '1' ) {
            id_nfs.push(nota.nota_fiscal_servico.id_nota_fiscal_servico);
          }
        });
      });

      id_nfs = _.uniq(id_nfs);

      if ( !id_nfs.length ) {
        this.$toast.add({
          severity: 'error',
          summary: 'Atenção',
          detail: 'Selecione apenas Notas Fiscais com o status "Gerada".',
          life: 3000
        });
        return;
      }

      if ( !confirm('Deseja realmente cancelar as Notas Fiscais geradas selecionadas?') ) {
        return;
      }

      this.$util.atualizar(this, {
        service: 'nota_fiscal_servico',
        func: 'cancelar_nf_pagamento_atendimentos_lote',
        redir_api: true,
        toast: true,
        dados: {
          id_nfs: id_nfs
        },
        callback: () => {
          this.load();
        }
      });

    },

    emitir_nfs_lote() {
        let nfs = [];
        let id_pags = []; 

        if(this.selecionados && Array.isArray(this.selecionados)) {
            this.selecionados.forEach((item) => {

                if(item.item_pagamento_atendimento &&
                    item.item_pagamento_atendimento.nota_fiscal_links &&
                    Array.isArray(item.item_pagamento_atendimento.nota_fiscal_links)) {

                    if ( !item.item_pagamento_atendimento.nota_fiscal_links.length ) { 

                        id_pags.push(item.item_pagamento_atendimento.id_pagamento_atendimento); 

                    } else { 

                        let tem_nf = false; 

                        item.item_pagamento_atendimento.nota_fiscal_links.forEach(nfl => {
                        // verificar as notas fiscais geradas (ch_status == '1')
                            if(nfl.nota_fiscal_servico && nfl.nota_fiscal_servico.ch_status && nfl.nota_fiscal_servico.ch_status == '1') {
                                //nfs.push({id_nota_fiscal_servico: nfl.nota_fiscal_servico.id_nota_fiscal_servico})
                                nfs.push(nfl.nota_fiscal_servico.id_nota_fiscal_servico);
                                tem_nf = true; 
                            }
                        });

                        if ( this.dados && this.dados.zoop && !tem_nf) { 
                            id_pags.push(item.item_pagamento_atendimento.id_pagamento_atendimento); 
                        }
                         
                    }

                } else if ( this.dados && this.dados.zoop && item.item_pagamento_atendimento ) { 

                    id_pags.push(item.item_pagamento_atendimento.id_pagamento_atendimento); 

                }
            });
        }

        console.log('id_pags', id_pags);

        if ( id_pags && id_pags.length && this.dados && this.dados.zoop ) { 

            id_pags = _.uniq(id_pags);

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "gerar_nf_pagamento_atendimentos_lote",
                redir_api: true,
                toast: true,
                dados: {
                    id_pagamento_atendimentos: id_pags
                },
                callback: () => {
                    this.load();
                }
            });
            return; 
        }

        if(nfs.length <= 0) {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: 'Não existem Notas Fiscais com o status "Gerada" nos itens selecionados',
                life: 3000
            });

            return;
        }

        if (!confirm("Deseja realmente emitir as Notas Fiscais selecionadas?")) {
            return;
        }

        this.$util.atualizar(this, {
            service: 'nota_fiscal_servico',
            func: 'emitir_notas_lote',
            redir_api: true,
            dados: {
                ids: nfs
            },
            callback: () => {
                this.load();
            }
        });

        // this.$refs.dispatchModal.executar_chunck(
        //     "nota_fiscal_servico",
        //     "emitir_nota_fiscal",
        //     nfs,
        //     '',
        //     {},
        //     1
        // );
    },
    
    consultar_nfs_lote() {
        let nfs = new Array();

        if(this.selecionados && Array.isArray(this.selecionados)) {
            this.selecionados.forEach((item) => {
                if(item.item_pagamento_atendimento &&
                   item.item_pagamento_atendimento.nota_fiscal_links &&
                   Array.isArray(item.item_pagamento_atendimento.nota_fiscal_links)) {

                    item.item_pagamento_atendimento.nota_fiscal_links.forEach(nfl => {
                       // verificar as notas fiscais geradas (ch_status == '1')
                       if(nfl.nota_fiscal_servico && nfl.nota_fiscal_servico.ch_status && nfl.nota_fiscal_servico.ch_status == '2') {
                          //nfs.push({id_nota_fiscal_servico: nfl.nota_fiscal_servico.id_nota_fiscal_servico})
                          nfs.push(nfl.nota_fiscal_servico.id_nota_fiscal_servico);
                       }
                    });

                }
            });
        }

        if(nfs.length <= 0) {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: 'Não existem Notas Fiscais com o status "Aguardando processamento" nos itens selecionados',
                life: 3000
            });

            return;
        }

        if (!confirm("Deseja realmente consultar as Notas Fiscais selecionadas?")) {
            return;
        }

        this.$util.atualizar(this, {
            service: 'nota_fiscal_servico',
            func: 'emitir_notas_lote',
            redir_api: true,
            dados: {
                ids: nfs,
                consultar: true
            },
            callback: () => {
                this.load();
            }
        });

        // this.$refs.dispatchModal.executar_chunck(
        //     "nota_fiscal_servico",
        //     "emitir_nota_fiscal",
        //     nfs,
        //     '',
        //     {},
        //     1
        // );
    },

    abrir_receber() {
      /*
      if ( this.dados && this.dados.pendentes && this.dados.pendentes.atendimentos && this.dados.pendentes.atendimentos.length > 0 ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: 'Existem atendimentos pendentes de pagamento.',
          life: 3000
        });
        return;
      }
      */

      this.info_baixa = false;
      this.validate = false;

      $('#recebimentoModal').modal('show');
    },

    receber () {

      this.$util.atualizar (this, {
        service: 'financeiro',
        func: this.fechamento_recepcao ? 'fechar_envio_particular' : 'receber',
        dados: {
          lancamentos: this.selecionados.map(item => { return { id_lancamento: item.id_lancamento } }),
          baixar: this.info_baixa,
          ...this.baixa,
          tem_pendente: ( this.dados && this.dados.pendentes && this.dados.pendentes.atendimentos && this.dados.pendentes.atendimentos.length > 0 ) ? true : false, 
        },
        modal: 'recebimentoModal',
        reload: true,
        toast: true,
        callback: () => {
          if ( this.fechamento_recepcao && this.filtro.status == 'P' ) {
            this.filtro.status = 'F';
          }
        }
      });

    },

    cancelar_recebimento (info_obs = false) {

        if ( !info_obs ) {
            this.validate = false; 
            this.obs_cancelamento = ""; 
            $('#fechamentoCancelamentoModal').modal('show');
            return;
        }

        this.$util.atualizar (this, {
            service: 'financeiro',
            func: this.fechamento_recepcao ? 'fechar_envio_particular' : 'receber',
            dados: {
                lancamentos: this.selecionados.map(item => { return { id_lancamento: item.id_lancamento } }),
                cancelar: true,
                obs: this.obs_cancelamento,
            },
            reload: true,
            toast: true,
            modal: 'fechamentoCancelamentoModal', 
        });

    },

    load (page = 1) {
      if ( this.montando )
        return;

      if ( this.referencia ) {
        if ( !this.from || !this.to || this.from > this.to ) {
          this.dados = null;
          return;
        }
      }

      this.$util.setCookie('presta-tpdata', this.filtro.tipo_data ? this.filtro.tipo_data : '' );

      this.$util.load (this, {
        service: 'financeiro',
        func: 'prestacao',
        page: page,
        parms: {
          referencia: this.referencia,
          from: this.from,
          to: this.to,
          ...this.filtro,
          recepcao: this.fechamento_recepcao,
          id_unidade_operacao: this.id_unidade_operacao,
          id_recepcao: this.id_recepcao,
          id_plano: this.id_plano,
          id_usuario: this.id_usuario,
          id_paciente: this.paciente ? this.paciente.id_pessoa : null,
          search: this.search,
          pago_para: this.pago_para, 
          split_zoop: this.split_zoop,
        },
      })
    },
  },

  created() {

    let info = this.$util.getCookie('presta-tpdata');

    if ( info ) { 
        this.filtro.tipo_data = info; 
    }

    if ( this.$route.params.periodo ) {

      console.log('params', this.$route.params);

      this.filtro.status = this.$route.params.status;
      this.id_plano = this.$route.params.id_plano ? this.$route.params.id_plano : '';
      this.id_forma_pagamento = this.$route.params.id_forma_pagamento ? this.$route.params.id_forma_pagamento : '';
      this.id_unidade_operacao = this.$route.params.id_unidade_operacao ? this.$route.params.id_unidade_operacao : '';
      this.filtro.periodo = this.$route.params.periodo;
      this.referencia = null;

      if ( this.$route.params.tipo_data == 'A' ) { 
        this.filtro.tipo_data = 'A'; 
      }

      if ( this.$route.params.pago_para == 'G' ) { 
        this.pago_para = 'G'; 
      }
      
    } else {

      if ( this.fechamento_recepcao ) {
        this.por_usuario = true;
        this.tipo_quebra = 'U';
        this.id_usuario = this.$store.state.user.id_usuario;
      } else {
        let info = this.$util.getCookie('presta-por-user');

        if ( info == 'N' ) { 
          this.tipo_quebra = 'G';
        } else if ( info == 'S' ) { 
          this.tipo_quebra = 'U';
        } else if ( info ) { 
          this.tipo_quebra = info;
        }

        this.por_usuario = ( this.$util.getCookie('presta-por-user') == 'N' ? false : true );
      }

      if ( this.referencia ) {
        this.from = this.referencia + '-01';
        this.to = moment(this.referencia + '-01').endOf('month').format('YYYY-MM-DD');
      }

    }

  },

  mounted() {

    if ( this.fechamento_recepcao ) {
      this.unidade = this.$store.state.user.id_unidade_operacao
        ? this.$store.state.user.id_unidade_operacao
        : this.$util.getCookie('id_unidade_operacao');

      this.id_unidade_operacao = this.unidade;

      this.$store.commit("setBreadcrumb", [
        { name: "Recepção", path: "/recepcao" },
        { name: "Fechamento Particular", path: "" }
      ]);
    } else {
      this.$store.commit("setBreadcrumb", [
        { name: "Financeiro", path: "/financeiro" },
        { name: "Prestação de Contas", path: "/financeiro/prestacao" }
      ]);

      if ( this.$route.path != '/financeiro/prestacao' ) {
        this.$router.push({ path: '/financeiro/prestacao' });
      }
    }

    this.$nextTick(() =>  {
      this.montando = false;
      this.load();

      $('.tooltip').tooltip('hide');
    });

  },

};
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>
